import { NavLink } from "react-router-dom";
import { CalendarDays, ClipboardList, LayoutGrid, Home, Megaphone, Newspaper, User } from "lucide-react";
import { AVVISI_KEYS, usePerm } from "../context/PermContext";

function tabs(admin, any) {
  const report = any("report.view", "report.edit");
  return [
    { to: "/", label: "Home", icon: Home, end: true },
    !report && { to: "/news", label: "News", icon: Newspaper },
    report && { to: "/report", label: "Report", icon: ClipboardList },
    any("turni.view", "turni.ferie", "turni.straordinari") && { to: "/turni", label: "Turni", icon: CalendarDays },
    any(...AVVISI_KEYS) && { to: "/avvisi", label: "Avvisi", icon: Megaphone },
    admin && { to: "/admin", label: "Admin", icon: LayoutGrid },
    { to: "/profilo", label: "Profilo", icon: User },
  ].filter(Boolean);
}

export const BottomNav = () => {
  const { any, admin } = usePerm();
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-slate-200 pb-[env(safe-area-inset-bottom)]" data-testid="bottom-nav">
      <div className="flex justify-around">
        {tabs(admin, any).map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end} data-testid={`bottom-nav-${to.replace(/\//g, "") || "home"}`}
            className={({ isActive }) => `flex-1 flex flex-col items-center gap-0.5 pt-2 pb-1.5 text-[11px] font-medium transition-colors ${isActive ? "text-[var(--teal)]" : "text-slate-400"}`}>
            {({ isActive }) => (<><span className={`px-4 py-1 rounded-full transition-colors ${isActive ? "bg-[var(--teal-soft)]" : ""}`}><Icon className="w-5 h-5" strokeWidth={isActive ? 2.2 : 1.8} /></span>{label}</>)}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
